import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import {
    ReactNode, useContext, useEffect, useId,
} from 'react';

import TabContext from './TabContext';

interface Props {
    children?: ReactNode;
    onClick?: () => void;
    selected?: boolean;
}

function TabItem({ children, onClick, selected }:Props) {
    const { variant, setCurrentId } = useContext(TabContext);
    const id = useId();
    useEffect(() => {
        if (selected) {
            setCurrentId(id);
        }
    }, [selected, id, setCurrentId]);
    if (variant === 'solid') {
        return (
            <SolidTabItem onClick={onClick}
                id={id}
                aria-label='tab'
                data-selected={!!selected}>
                <Text size='body-short'
                    color={selected ? colors.textSecondary : colors.textThird}
                    fontWeight='bold'>
                    {children}
                </Text>
            </SolidTabItem>
        );
    }
    return (
        <LineTabItem id={id}
            aria-label='tab'
            data-selected={!!selected}
            onClick={onClick} >
            <Text size='body-short'
                fontWeight={selected ? 'bold' : 'regular'} >
                {children}
            </Text>
        </LineTabItem>
    );
}

const LineTabItem = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 16px 0;
`;

const SolidTabItem = styled.div`
    align-items: center;
    border-radius: 6px;
    display: flex;
    height: 36px;
    justify-content: center;
    padding: 8px;
`;

export default TabItem;
